// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3wJty","obliqueLineWrap":"membershipbadge_obliqueLineWrap__2FlvC","obliqueLine":"membershipbadge_obliqueLine__1tCnA"};